// ** React Imports
import { lazy } from 'react';

const MessageSubscriber = [
  {
    path: 'message/subscriber',
    component: lazy(() => import('views/message-subscribers')),
  },
];

export default MessageSubscriber;
